/* eslint-disable camelcase */
<template>
  <div class="teleInfos">
    <el-card>
      <el-button type="primary" slot="header" @click="addTel()">{{$t('lang.lab_addPark')}}</el-button>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 车场名称 -->
        <el-table-column prop="parkName" :label="$t('lang.lab_parkName')"></el-table-column>
        <!-- 车位数 -->
        <el-table-column prop="totalNum" :label="$t('lang.lab_carTtotalNum')"></el-table-column>
        <!-- 允许重复入场 
        <el-table-column prop="isRepeat" :label="$t('lang.lab_isRepeat')">
          <template slot-scope="scope">
            <span v-if="scope.row.isRepeat === 0">{{$t('lang.lab_isAllow')}}</span>
            <span v-else>{{$t('lang.lab_noAllow')}}</span>
          </template>
        </el-table-column>-->
        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="goControl(scope.row.id)">{{$t('lang.lab_carParkControl')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="600px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- 名称 -->
        <el-form-item :label="$t('lang.lab_parkName')" prop="parkName">
          <el-input v-model="form.parkName" :placeholder="$t('lang.lab_parkName')" maxlength="11"></el-input>
        </el-form-item>
        <!-- 总人数 -->
        <el-form-item :label="$t('lang.lab_carTtotalNum')" prop="totalNum">
          <el-input v-model="form.totalNum" :placeholder="$t('lang.lab_carTtotalNum')" maxlength="6" @input="keyBA">
          </el-input>
        </el-form-item>
        <!--允许重复入场 
        <el-form-item :label="$t('lang.lab_isRepeat')" prop="isRepeat">
          <el-radio v-model="form.isRepeat" label='1'>{{$t('lang.lab_noAllow')}}</el-radio>
          <el-radio v-model="form.isRepeat" label='0'>{{$t('lang.lab_isAllow')}}</el-radio>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 添加规则弹框 -->
    <el-dialog :title="titleCommonRuleShow" :visible.sync="diaCommonRuleIsShow" :close-on-click-modal="false" center
      top="130px" width="800px" @closed="handleCommonRuleDialogClosed">
      <el-form :model="commonRuleform" :rules="commonrules" ref="commonRuleform"
        :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_isRepeat')" prop="isRepeat">
          <el-radio v-model="commonRuleform.isRepeat" label='1'
            @click.native.prevent="onisRepeatChange('1')">{{$t('lang.lab_isAllow')}}
          </el-radio>
          <el-radio v-model="commonRuleform.isRepeat" label='0'
            @click.native.prevent="onisRepeatChange('0')">{{$t('lang.lab_noAllow')}}
          </el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="commonRuleclear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="saveCommonRule('commonRuleform')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:teleInfo
   *@Description:电话信息
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        isDisabled: true, // 按钮置灰
        saveData: '', // 存储json字符串
        name: '', // 名称
        content: '', // 电话
        serviceTime: '', // 服务时间
        editId: '', // 接收参数
        titleShow: '', // 弹框标题
        titleCommonRuleShow: '', // 规则弹框标题
        diaIsShow: false, // 弹框是否显示
        diaCommonRuleIsShow: false, // 规则弹框是否显示
        pageNum: 1, // 页数
        pageSize: 10, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        multipleSelection: [], // 多选框
        type: '', // 判断checkbox的值
        teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
        form: {
          parkName: '',
          totalNum: '',
        },
        commonRuleform: {
          isRepeat: '',
        },
        rules: {
          parkName: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleParkName'),
            trigger: 'blur'
          }],
          totalNum: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleCarTtotalNum'),
            trigger: 'blur'
          }]
        },
        commonrules: {
          isRepeat: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleruleSearch'),
            trigger: 'blur'
          }]
        }
      }
    },
    // 初始化
    created() {
      this.topics()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.topics()
      },
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 用户名只能输入数字
      keyBA() {
        // 仅保留数字和"."
        this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
          this.form.totalNum = parseFloat(this.form.totalNum)
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      topics() {
        let loading = this.$loading()
        this.$get(
          `/carPark?gardenId=${this.gardenId}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
              if (res.list.length == 1) {
                  this.goControl(res.list[0].id)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 添加电话
      addTel() {
        this.editId = ''
        this.titleShow = this.$i18n.t('lang.lab_addPark')
        this.form.parkName = ''
        this.form.totalNum = ''
        this.diaIsShow = true
      },
      // 修改电话信息
      changeTel(row) {
        this.editId = row.id
        this.titleShow = this.$i18n.t('lang.lab_changePark')
        this.form.parkName = row.parkName
        this.form.totalNum = Number(row.totalNum)
        this.saveData = JSON.stringify(this.form)
        this.diaIsShow = true
      },
      changeRule(id) {
        this.editId = id
        this.titleCommonRuleShow = this.$i18n.t('lang.lab_ruleManage')
        this.diaCommonRuleIsShow = true
        this.getCommonRule(id)
      },
      getCommonRule(id) {
        let loading = this.$loading()
        this.$get(
          `/carCommonRule?parkId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              for (let i = 0; i < res.list.length; i++) {
                if (res.list[i].ruleKey == 'IsRepeat') {
                  this.$set(this.commonRuleform, 'isRepeat', String(res.list[i].ruleValue))
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      goControl(id) {
        this.$router.push({
          path: '/manage/carCameraList',
          query: {
			parkId: id,
			gardenId: this.gardenId
			
          }
        })
      },
      addGate(id) {
        this.$router.push({
          path: '/manage/carGateList',
          query: {
            id: id
          }
        })
      },
      // 删除
      delTele(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`carPark/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.editId === '') {
              let params = {
                gardenId: this.gardenId,
                parkName: this.form.parkName,
                totalNum: this.form.totalNum
              }
              if (this.gardenId === 0) {
                this.$message.error(this.$i18n.t('lang.reportPleaseSelectVillage'))
                return
              }
              let loading = this.$loading()
              this.$post(`/carPark/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let loading = this.$loading()
              let params = {
                parkName: this.form.parkName,
                totalNum: this.form.totalNum
              }
              this.$patch(`/carPark/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              console.log(params.type)
            }
          }
        })
      },
      saveCommonRule(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            var commonRule = []
            let obj = this.commonRuleform
            for (let i in obj) {
              var name = ''
              var key = ''
              if (i == 'isRepeat') {
                name = '重复入场'
                key = 'IsRepeat'
              }
              var o = {
                'RuleName': name,
                'RuleKey': key,
                'RuleValue': obj[i],
                'ParkId': this.editId
              }
              commonRule.push(o)
            }
            let loading = this.$loading()

            this.$postJson(`/carCommonRule/${this.editId}`, JSON.stringify(commonRule)).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaCommonRuleIsShow = false
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      clear() {
        this.$refs.form.resetFields()
        this.form.parkName = ''
        this.form.totalNum = ''
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
      // 监听关闭dialog
      handleCommonRuleDialogClosed() {
        this.commonRuleclear()
      },
      commonRuleclear() {
        this.$refs.commonRuleform.resetFields()
        this.commonRuleform.isRepeat = ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.topics()
      },
      onisRepeatChange(e) {
        console.log(e)
        // 当点击已经选中的把 activeModel 置空，就是取消选中，并返回
         if (this.commonRuleform.isRepeat === e) {
          this.commonRuleform.isRepeat = ''
          return
        }
        // 不是选中，选中当前点击 Radio
        this.commonRuleform.isRepeat = e
        // 选中操作
      }
    }
  }
</script>

<style lang="scss">
</style>